export default __webpack_public_path__ + "static/media/mentor-1.c53af046.png";